import PriceBreakdownList from './PriceBreakdownList';

export default PriceBreakdownList;
